import { type RefObject, useEffect, useState } from 'react';

/**
 * Следит за HTML-элементом и возвращает его размеры.
 * @param element  HTML-элемент, за которым нужно следить
 */
export const useElementSizes = (element: RefObject<HTMLElement>) => {
  const [height, setHeight] = useState<number>(0);
  const [width, setWidth] = useState<number>(0);

  useEffect(() => {
    if (!element.current) {
      return;
    }

    const resizeObserver = new ResizeObserver(() => {
      // Теоретически, элемент может исчезнуть уже после создания обсервера
      if (!element.current) {
        return;
      }

      if (element.current.offsetHeight !== height) {
        setHeight(element.current.offsetHeight);
      }

      if (element.current.offsetWidth !== width) {
        setWidth(element.current.offsetWidth);
      }
    });

    resizeObserver.observe(element.current);

    return () => {
      resizeObserver.disconnect();
    };

  }, [element.current]);

  return { height, width };
};
